import { render, staticRenderFns } from "./kechengzixun.vue?vue&type=template&id=64032192&scoped=true"
import script from "./kechengzixun.vue?vue&type=script&lang=js"
export * from "./kechengzixun.vue?vue&type=script&lang=js"
import style0 from "./kechengzixun.vue?vue&type=style&index=0&id=64032192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64032192",
  null
  
)

export default component.exports